import { createContext } from 'react'
import { FeedbackContextData } from './FeedbackContext.types'

export const FeedbackContext = createContext<FeedbackContextData>({
    showInfo: (message: string) => {},
    showSuccess: (message: string) => {},
    showWarning: (message: string) => {},
    showError: (message: string) => {},
    showBackdrop: (message?: string) => {},
    closeBackdrop: () => {},
})
